export default [
  {
    header: "المعاملات ",
    icon: "FileIcon",
    children: [
      {
        title: "طلبات المعاملات ",
        route: "transactions",
        icon: "FileIcon",
        slug: "ngo_transaction_requests",
      },
      {
        title: "معاملات التوسّط ",
        route: "mediation-requests",
        icon: "FileIcon",
        slug: "mediation_request",
      },
      
    ],
  },
];
